<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template v-if="searchShow">
            <el-input
                v-model="search.searchKey"
                clas="input_search"
                clearable
                placeholder="搜索关键字"
                style="margin-right: 10px"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-select
                v-model="search.payStatus"
                clearable
                filterable
                placeholder="支付状态"
            >
              <el-option
                  v-for="item in PAY_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.paymentType"
                clearable
                filterable
                placeholder="支付方式"
            >
              <el-option
                  v-for="item in paymentList"
                  :key="item.paymentType"
                  :label="item.name"
                  :value="item.paymentType"
              ></el-option>
            </el-select>
            <el-select v-model="search.putWay" clearable filterable placeholder="投放方式">
              <el-option
                  v-for="item in touFangList"
                  :key="item.enumId"
                  :label="item.enumName"
                  :value="item.enumVal"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.appInfoId"
                clearable
                filterable
                placeholder="下单应用"
            >
              <el-option
                  v-for="item in appList"
                  :key="item.appInfoId"
                  :label="item.appName"
                  :value="item.appInfoId"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="下单渠道"
            >
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="item.name+'('+item.account+')'"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <el-select v-model="search.newChannelOrder" clearable filterable placeholder="来源">
              <el-option
                  v-for="item in NEWUSER_ORDER"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select v-model="search.countryCode" clearable filterable placeholder="国家/地区">
              <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-model="search.ipCountryCode" clearable filterable placeholder="IP国家/地区">
              <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              ></el-option>
            </el-select>
            <el-select v-model="search.examInfoId" clearable filterable placeholder="测评题">
              <el-option
                  v-for="item in examList"
                  :key="item.examInfoId"
                  :label="item.name"
                  :value="item.examInfoId"
              ></el-option>
            </el-select>
            <div class="block timeblock" style="width: 400px;margin-bottom: 10px">
              <el-select
                  v-model="search.timeType"
                  class='xq_time_select'
                  clearable
                  placeholder="选择时间"
                  style="margin: 0"
              >
                <el-option
                    v-for="item in TIME_TYPE"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                ></el-option>
              </el-select>
              <el-date-picker

                  v-model="value2"
                  :picker-options="pickerOptions"
                  align="right"
                  class='xq_time_picker'
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </div>

            <el-button size="medium" type="primary" @click="getserviceList(1)"
            >查询
            </el-button
            >
          </template>
          <el-button v-if="downShow" size="medium" type="primary" @click="upserviceList"
          >下载
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              border
              row-key="customerServiceId"
              size="medium"
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="60">
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="国家/地区" min-width="90" prop="countryName">
            </el-table-column>
            <el-table-column label="用户" min-width="180" prop="userId">
              <template slot-scope="scope">
                <div>{{ scope.row.userName }}</div>
                <div>
                  <!-- <div>ID:{{ scope.row.userId ||'-'}}</div> -->
                  <!-- <div>邮箱:{{ scope.row.email ||'-'}}</div>               -->
                  <div>状态:{{ scope.row.subscriptionStatus ||'-'}}</div>              
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单号" min-width="200" prop="orderNumber">
            </el-table-column>
            <el-table-column label="测评来源" min-width="270" prop="examName">
              <template slot-scope="scope">
                <div>{{scope.row.examName}}</div>
                <div>渠道：{{scope.row.channelType}}</div>
                <div>来源：{{scope.row.channelUrl}}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付" prop="paymentType" width="120">
              <template slot-scope="scope"> 
                <div>{{scope.row.paymentType}}</div>
                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 0">待支付</el-tag>
                <el-tag type="info" effect="dark" size="mini" v-if="scope.row.payStatus == 3">取消支付</el-tag>
                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 5">支付确认中</el-tag>
                <el-tag type="success" effect="dark" size="mini" v-if="scope.row.payStatus == 10">支付成功</el-tag>
                <el-tag type="danger" effect="dark" size="mini" v-if="scope.row.payStatus == 15">支付失败</el-tag>
                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.payStatus == 20">退款中</el-tag>
                <el-tag type="success" effect="dark" size="mini" v-if="scope.row.payStatus == 25">退款完成</el-tag>
                    
                <div>${{ scope.row.payMoney?scope.row.payMoney / 100:'-' }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="支付ID" min-width="200" prop="transactionId">
            </el-table-column> -->
            <el-table-column label="支付信息" min-width="240" prop="finishTime">
              <template slot-scope="scope">
                <div>ID:{{scope.row.transactionId}}</div>
                <div v-if="scope.row.finishTime">完成时间:{{formatDate(scope.row.finishTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
                <div v-if="scope.row.nextBillingDate">下次扣款:{{formatDate(scope.row.nextBillingDate, 'YYYY-MM-DD HH:mm:ss')}}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="下次扣款时间" min-width="160" prop="nextBillingDate">
            </el-table-column> -->
            <el-table-column label="订阅ID" prop="subscriptionId" width="70">
            </el-table-column>
            <!-- <el-table-column label="推广渠道" prop="channelType" width="120">
            </el-table-column> -->
            <el-table-column label="测评ID" prop="examOrderId" width="70">
            </el-table-column>

            <el-table-column label="测评信息" prop="examScore" width="240">
              <template slot-scope="scope">
                <div> 得分:{{scope.row.examScore}}</div>
                <div>答题时长:{{scope.row.examTimes}}</div>
                <div v-if="scope.row.startTime">开始时间:{{formatDate(scope.row.startTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
                <div v-if="scope.row.endTime">结束时间:{{formatDate(scope.row.endTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
              </template>
            </el-table-column>

            <el-table-column label="用户IP" min-width="180" prop="ip">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <div class="button_code">
                  <el-button
                      v-if="detailShow"
                      size="mini"
                      @click="getOrderDetail(scope.row)"
                  >详情
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="showUserActionLogs(scope.row)"
                  >用户日志
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :total="page.count"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
        title="用户行为日志"
        :visible.sync="userActionLogsDialogVisible"
        width="760px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
        <el-form v-loading="userActionLogsLoading">
          <b>订单号：</b>{{params.orderNumber}} <br/>
          <b>用户ID：</b>{{params.userId}} <br/>
          <b>用户邮箱：</b>{{params.email}} <br/>
          <b>用户IP：</b>{{params.ip}} <br/><br/>
        <el-table
            :data="userActionLogs"
            border
            row-key="id"
            size="medium"
            style="width: 100%"
            height="500px"
        >
          <el-table-column label="时间" min-width="60" prop="ctime">
          </el-table-column>
          <el-table-column label="事件" min-width="180" prop="action">
          </el-table-column>
        </el-table>
        </el-form>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="userActionLogsDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  PAY_STATUS,
  PAYMENT_TYPE,
  NEWUSER_ORDER,
  TIME_TYPE,
} from "@/config";

import {isEmpty} from "@utils/tools/index";
import { downloadFile } from '@/utils/filters/upload.js'
import { formatDate } from "@/utils/filters/filter";
export default {
  data() {
    return {
      qrcodeText: "舒工请你付款来了", //二维码内容（扫码识别后需要访问的网址）
      amount: 168,//金额
      PAGE_SIZE,
      PAY_STATUS,
      PAYMENT_TYPE,
      NEWUSER_ORDER,
      TIME_TYPE,
      paymentList:[],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      countryList: [],
      examList: [],
      isEmpty,//需要在此初始化才可以在页面使用
      value2: "", //以上时间选择器
      enumCode: "PUT_WAY",
      touFangList: [], //渠道用户投放方式
      categoryList: [], //测评题分类数组
      dictDataSelect: "", //测评题tree点击后显示
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [], //渠道类型list
      appList: [], //归属应用appid
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表
      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写客服名称"}],
        account: [{required: true, message: "请填写账号"}],
        offTime: [{required: true, message: "请填写结束时间"}],
        onTime: [{required: true, message: "请填写开始时间"}],
      }, //表单验证提示

      searchShow: false,
      downShow: false,
      detailShow: false,
      qrcodeShow: false,
      userActionLogsDialogVisible: false,
      userActionLogsLoading: false,
      userActionLogs: [],
      formatDate,
    };
  },
  mounted() {
    this.getAppList();
    this.getChannelList();
    this.gettouFangList();
    this.getCategoryList();
    this.getserviceList();
    this.getPermissionButtonList();
    this.getCountryList();
    this.getExamList();
    this.getPaymentList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    async getCountryList() {
      const {data: res} = await this.$post(
          `/country/page`, {pageNo: 1, pageSize: 1000},
      );
      this.countryList = res.data;
    },
    async getPaymentList(){
      const {data: resData} = await this.$get(
          "/payment/type/list",
      );

      if (resData.result != 200) return;
      this.paymentList = resData.data;
    },
    async getExamList() {
      const {data} = await this.$get(`/exam/list?status=1&pageNo=1&pageSize=1000`);
      this.examList = data.data;
    },
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'order:examList:query') {
            this.searchShow = true
          }
          if (item.code == 'order:examList:down') {
            this.downShow = true
          }
          if (item.code == "order:examList:detail") {
            this.detailShow = true
          }
          if (item.code == "order:examList:detail:qrcode") {
            this.qrcodeShow = true
          }
        })
      }
    },

    goShowReport(item) {
      let url = 'http://exl.xyunxin.com/report/content-' + item.orderNumber
      // let url = 'http://test.h5.cdtaotan.com/report/content-'+item.orderNumber
      window.open(url)
    },
    //获取归属应用
    async getAppList() {
      const {data: orgData} = await this.$get(`/app/list?paging=false&appType=WEBSIT`);
      this.appList = orgData.data;
    },
    //获取渠道账号
    async getChannelList() {
      // const { data: orgData } = await this.$get(`/channel/type/list`);
      const {data: orgData} = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },
    // 获取渠道用户投放方式
    async gettouFangList() {

      const {data: orgData} = await this.$get(`/enums/list/${this.enumCode}`);

      this.touFangList = orgData.data;
    },
    //get categoryList:[],//测评题分类数组
    async getCategoryList() {
      try {
        const {data: res} = await this.$get(`/exam/category/list?tree=true`, {
          headers: {
            isLoading: true,
          },
        });
        if (res && res.data) {
          this.categoryList = res.data;
        } else {
          this.categoryList = [];
          console.warn('获取类别选项数据失败: 响应数据为空');
        }
      } catch (error) {
        console.error('获取类别选项数据失败:', error);
        this.categoryList = [];
        this.$message.error('获取类别选项数据失败，请稍后重试');
      }
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime = obj.startTime ? obj.startTime : ''
      let endTime = obj.endTime ? obj.endTime : ''
      if (startTime && endTime) {
        // const {data: res} = await this.$get(
        //     `/exam/order/export/create`,
        //     {params: {...this.search}},
        //     {
        //       headers: {
        //         // isLoading: true,
        //       },
        //     }
        // );
        // this.$message.success(res.data)
        let queryString = ''
        for (const key in this.search) {
          if (this.search.hasOwnProperty(key) && this.search[key]) {
            queryString += `${key}=${this.search[key]}&`;
          }
        }
        // 移除字符串末尾的多余的 '&' 符号
        queryString = queryString.slice(0, -1);

        // window.open(`/taotan_admin_api/exam/order/export/examOrder?timeType=${this.search.timeType}&startTime=${startTime}&endTime=${endTime}`);
        const downloadUrl = `/taotan_admin_api/exam/order/export/examOrderV1?${queryString}`
        downloadFile(downloadUrl, `examOrder_${new Date().getTime()}.csv`)
      } else {
        this.$message.warning('请选择时间')
      }
    },
    //订单列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.pageNo = 1;
      }
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      } else {
        delete this.search.startTime
        delete this.search.endTime
        delete this.search.timeType
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      this.loading = true;
      const search = this.search;
      ['examInfoId', 'countryCode'].forEach(
          itemKey => {
            if (!search[itemKey]) {
              delete search[itemKey]
            }
          }
      )
      this.removeEmptyProperties(search)
      const {data: res} = await this.$get(
          `/exam/order/listV1`,
          {params: {...search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      let list = res.data
      if (list) {
        // 新接口返回的金额已经是正确单位，不需要除以100
        // item.payMoney = item.payMoney / 100
      }
      this.tableData = list;
      this.page.count = res.page.count;
    },
    removeEmptyProperties(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
          delete obj[key];
        }
      }
    },
    //订单详情
    getOrderDetail(row) {
      this.$router.push({
        name: 'TEST_ORDER_DETAIL',
        query: {
          title: '测评订单',
          value: JSON.stringify(row.orderNumber),
        }
      })
    },
    //用户日志
    async showUserActionLogs(row) {
      this.userActionLogsDialogVisible = true;
      this.userActionLogsLoading = true;
      const {data: resData} = await this.$get(
          `/exam/order/userActionLogs`,
          {params: {orderNumber: row.orderNumber}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.userActionLogsLoading = false;
      this.userActionLogs = resData.data;
      this.params = row;
    },

    //tree 点击  categoryId:测评题分类id
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.search.categoryId = node.categoryId;
      this.$refs.selectReport.blur();
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.el-select {
  margin-bottom: 10px;
  margin-right: 10px;
}

.name-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-left: 10px;

  img {
    width: 25px;
    height: 25px;
  }
}

.button_code {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-button--small, .el-button--small.is-round {
    padding: 11px 15px !important;
  }
}
</style>
